import React from 'react';

import { DOC_BASE_URL } from '../../../util/constant';

export default function Holidays() {
  return (
    <div className="w-full overflow-y-auto h-[85vh]">
      <iframe
        src={`${DOC_BASE_URL}Holiday%20Calendar-20250128021129.html`}
        width="100%"
        height="100%"
        title="Document Viewer"
        className=""
        frameBorder="0"
      ></iframe>
    </div>
  );
}
